export enum NotifyType {
    alert,
    success,
    error,
    warning,
    info,
    primary
}
export enum NotifyTheme {
    noty,
    alert
}


// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/interface/INotification.ts